var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('transition-group',{attrs:{"name":"fade","tag":"b-row"}},_vm._l((_vm.purifiers),function(purifier,index){return _c('purifier-view',{key:purifier.id,attrs:{"purifier":purifier,"index":index}})}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72ad92de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectorView.vue
// module id = null
// module chunks = 